import React from 'react';
import styled from 'styled-components';
import { openBooking, openTasks } from '../HomePage/Hero';

const BookSection = styled.section`
  padding: 5rem 0;
  background: #253ec6;
  color: white;
`;

const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 1.5rem;
  padding: 0.5rem 1rem;
  margin: 0 auto 3rem;
  width: fit-content;
  font-size: 0.9rem;
`;

const StarIcon = styled.span`
  color: white;
  font-size: 1rem;
`;

const SectionTitle = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 3rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 1.5rem;
  color: white;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const SectionDescription = styled.p`
  text-align: center;
  font-size: 1.1rem;
  color: white;
  max-width: 600px;
  margin: 0 auto 3rem;
  line-height: 1.6;
  opacity: 0.9;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 3rem;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
  }
`;

const PrimaryButton = styled.button`
  background: white;
  color: #253ec6;
  border: none;
  border-radius: 5px;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  font-family: Poppins, sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: #253ec6;
    transform: scale(1.05);
  }
`;

const SecondaryButton = styled.button`
  background: transparent;
  color: white;
  border: 1px solid white;
  border-radius: 5px;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  font-family: Poppins, sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: white;
    transform: scale(1.05);
  }
`;

const FeaturesList = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;
  font-size: 0.95rem;
`;

const FeatureDot = styled.div`
  width: 6px;
  height: 6px;
  background: white;
  border-radius: 50%;
`;

export default function Book() {
  return (
    <BookSection id="get-started">
      <div className="container">
        <Banner>
          <StarIcon>✦</StarIcon>
          <span>Join 2500+ residents already using Homero</span>
        </Banner>

        <SectionTitle>
          Your clean home is
          <br />
          one click away
        </SectionTitle>

        <SectionDescription>
          Experience the future of residential cleaning. Trusted by residents,
          loved by buildings.
        </SectionDescription>

        <ButtonGroup>
          <PrimaryButton
            onClick={() => openBooking(undefined, 'residents-plan')}
          >
            Build my plan →
          </PrimaryButton>
          <SecondaryButton
            onClick={() => openTasks(undefined, 'residents-task')}
          >
            Book a task →
          </SecondaryButton>
        </ButtonGroup>

        <FeaturesList>
          <FeatureItem>
            <FeatureDot />
            <span>Resident-only access</span>
          </FeatureItem>
          <FeatureItem>
            <FeatureDot />
            <span>No hourly minimums</span>
          </FeatureItem>
          <FeatureItem>
            <FeatureDot />
            <span>Transparent pricing</span>
          </FeatureItem>
        </FeaturesList>
      </div>
    </BookSection>
  );
}
